import { indexRoute, rootRoute } from './__root';
import { blastDesignContextRoute } from './blast_design_context';
import { blastNameRoute, blastsIndexRoute, blastsRootRoute } from './blasts';
import { changelogRoute } from './changelog';
import { blastOptimisationsRoute, blastOptimiserViewerRoute } from './optimiser';

/**
 * Route tree:
 * /                                                    → redirect to /blasts
 * ├── /blasts                                          → Blasts section
 * │   ├── /                                            → Blast list (entry point)
 * │   ├── /$blastName                                  → redirect to /blasts
 * │   │   └── /optimisations                           → Blast optimisations list table
 * │   │   │   └── /$optimiserId                        → Blast optimisation pattern design viewer
 * │   │   └── /design_context                          → Blast design context viewer
 */
export const routeTree = rootRoute.addChildren([
  indexRoute,
  changelogRoute,
  blastsRootRoute.addChildren([
    blastsIndexRoute,
    blastNameRoute,
    blastOptimisationsRoute,
    blastOptimiserViewerRoute,
    blastDesignContextRoute,
  ]),
]);
